module.exports = __webpack_public_path__ + "img/employNumeric.5c268c91.svg";